<div class="input-group" [class.-active]="checkForValue()" [class.-focus]="isFocused">
  <input
    #input
    [type]="type"
    [min]="min"
    [max]="max"
    (focus)="isFocused = true"
    (blur)="onBlur(input.value)"
    class="form-control"
    [ngModel]="value"
    (ngModelChange)="onChange($event)"
  />
  <div class="input-group-append">
    <span class="input-group-text unit">{{ unit }}</span>
  </div>
</div>
